/* FERRAGRO - % de ganancia B2B en la ficha de producto (PDP).
   Lee el precio B2B (costo) y el PVS que pinta SparkLayer, calcula la
   ganancia y muestra un badge en la zona de precio. Solo en PDP.
   Reversible: quitar el <script> de favicon.liquid y borrar este archivo.
   FORMULA: 'markup' (sobre tu costo) o 'margin' (sobre el PVS). */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var FORMULA = 'markup';
  var LABEL = 'Tu ganancia';

  function money(el) {
    return parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
  }

  var running = false;
  function render() {
    if (running) return;
    running = true;
    var wraps = document.querySelectorAll('.product-price-wrapper.with-rrp');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var leaves = wrap.querySelectorAll('*');
      var vals = [];
      for (var j = 0; j < leaves.length; j++) {
        var n = leaves[j];
        if (n.children.length === 0 && /\$\s*[0-9]/.test(n.textContent)) {
          var v = money(n);
          if (v > 0) vals.push(v);
        }
      }
      if (vals.length < 2) continue;
      var cost = Math.min.apply(null, vals);
      var pvs = Math.max.apply(null, vals);
      if (pvs <= cost) continue;

      var pct = (FORMULA === 'margin')
        ? Math.round((pvs - cost) / pvs * 100)
        : Math.round((pvs - cost) / cost * 100);

      var text = LABEL + ': +' + pct + '%';
      var host = wrap.parentNode || wrap;
      var badge = host.querySelector('.fg-margin');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'fg-margin';
        badge.style.cssText = 'display:inline-block;margin-top:6px;background:#e7f3e3;color:#145207;font-weight:700;font-size:0.9rem;padding:4px 10px;border-radius:999px;line-height:1.2;';
        if (wrap.nextSibling) host.insertBefore(badge, wrap.nextSibling);
        else host.appendChild(badge);
      }
      if (badge.textContent !== text) badge.textContent = text;
    }
    running = false;
  }

  function boot() {
    render();
    var obs = new MutationObserver(function () {
      if (running) return;
      obs.disconnect();
      render();
      obs.observe(document.body, { subtree: true, childList: true, characterData: true });
    });
    obs.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
